import { OnInit } from '@angular/core';
/**
 * Angular imports.
 */
import { Component, EventEmitter, Input, Output, OnDestroy } from '@angular/core';

/**
 * Model imports.
 */
import { CommunityList } from '../../onboarding/interface/global.model';

/**
 * Constant imports
 */
import { COMMUNITY_LIST_TYPE, NUMBERS, PRODUCT_TYPE_CONSTANT, SCREEN_NAME } from '../../constants/app.constants';
import { NewLanguageService } from '../../dataservices/new-language/new-language.service';

/**
 * Show the card of the community list.
 */
@Component({
  selector: 'app-community-card',
  templateUrl: './community-card.component.html',
  styleUrls: ['./community-card.component.scss']
})
export class CommunityCardComponent implements OnInit, OnDestroy {

  /**
   * Receive the object for the community detail.
   * Translation to use in template
   * Community is past key.
   */
  @Input() communityDetails: CommunityList;
  @Input() translations: { [key: string]: string } = {};
  @Input() isPastCommunity?: boolean;
  /**
   * Showing public community or not.
   */
  @Input() showPublicCommunityList?:boolean;

  /**
   * Emit the filter key outside.
   */
  @Output() emitFilterKey: EventEmitter<string> = new EventEmitter();
  /**
   * constant for community list type
   * constr for Numbers
   */
  public communityListType = COMMUNITY_LIST_TYPE;
  public numbers = NUMBERS;
  /**
   * Analytics session time.
   */
  private sessiontime = { 'start_time': '', 'end_time': '' };
  /**
   * Show  my all community without public community.
   */
  public showSingleMyCommunity = false;
  /**
   * Necessary instances.
   */
  constructor(
    public mls: NewLanguageService,
  ) { }
  /**
   * Call on init.
   */
  ngOnInit(): void {
    const d = new Date();
    this.sessiontime.start_time = d.getTime().toString();
  }

  /**
   * Emit the filter key outside.
   */
  filter(key: string): void {
    const d = new Date();
    this.sessiontime.end_time = d.getTime().toString();
    this.emitFilterKey.emit(key);
    this.showSingleMyCommunity = true;
  }

  /**
   * Unsubscribe on ondestroy.
   */
  ngOnDestroy(): void {
    const d = new Date();
    this.sessiontime.end_time = d.getTime().toString();
  }
}
